import { TeamPanel } from "./team-panel";
import { RolesPanel } from "./roles-panel";

// Combined "Team & roles" store-settings section: team members + invitations
// (TeamPanel) stacked above role definitions + permissions (RolesPanel). Both
// panels self-resolve the store slug and their own data, so no props are
// needed here.
export function TeamRolesPanel() {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
      <TeamPanel />
      <RolesPanel />
    </div>
  );
}
